/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { first, filter } from 'lodash';
import { isEmptyValue, composeValidators } from '@blend/enterprise-components';

import { getPasswordRequirements } from 'id-utils/password';
const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const emailValidator = (value: string) => {
  return emailRegex.test(value)
    ? undefined
    : 'Email should include the @ symbol and a domain name (ex: yourname@domain.com)';
};

export const requiredEmailValidator = composeValidators(isEmptyValue('Please input your email.'), emailValidator);

export const emptyPasswordValidator = isEmptyValue('Please input your password.');

export const emptyCheckboxValidator = isEmptyValue('This field is required.');

export const strengthAndMatchValidator = (
  password: string,
  { confirmedPassword }: Record<string, any>,
): string | undefined => {
  const requirements = filter(getPasswordRequirements(password, confirmedPassword), { isMet: false });
  return requirements.length ? first(requirements)?.description : undefined;
};
